var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUUserPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "url(#paint0_linear_28_4891)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_4891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5853 15.6973L6.496 9.60733C6.79099 9.11821 7.20703 8.71336 7.70402 8.43182C8.201 8.15028 8.76215 8.00156 9.33333 8H14.196C13.8499 9.18235 13.9828 10.4534 14.5659 11.5386C15.149 12.6238 16.1357 13.4361 17.3127 13.8L15.4147 15.6987C15.0388 16.0727 14.53 16.2826 13.9997 16.2823C13.4694 16.2821 12.9609 16.0717 12.5853 15.6973ZM16.3573 16.64C15.7315 17.264 14.8838 17.6144 14 17.6144C13.1162 17.6144 12.2685 17.264 11.6427 16.64L6.03067 11.028C6.02133 11.1333 6 11.2287 6 11.3333V18.6667C6.00106 19.5504 6.35259 20.3976 6.97748 21.0225C7.60237 21.6474 8.4496 21.9989 9.33333 22H18.6667C19.5504 21.9989 20.3976 21.6474 21.0225 21.0225C21.6474 20.3976 21.9989 19.5504 22 18.6667V12.596C21.2074 13.4069 20.1456 13.9001 19.0147 13.9827L16.3573 16.64ZM16 10H18V12C18 12.1768 18.0702 12.3464 18.1953 12.4714C18.3203 12.5964 18.4899 12.6667 18.6667 12.6667C18.8435 12.6667 19.013 12.5964 19.1381 12.4714C19.2631 12.3464 19.3333 12.1768 19.3333 12V10H21.3333C21.5101 10 21.6797 9.92976 21.8047 9.80474C21.9298 9.67971 22 9.51014 22 9.33333C22 9.15652 21.9298 8.98695 21.8047 8.86193C21.6797 8.7369 21.5101 8.66667 21.3333 8.66667H19.3333V6.66667C19.3333 6.48986 19.2631 6.32029 19.1381 6.19526C19.013 6.07024 18.8435 6 18.6667 6C18.4899 6 18.3203 6.07024 18.1953 6.19526C18.0702 6.32029 18 6.48986 18 6.66667V8.66667H16C15.8232 8.66667 15.6536 8.7369 15.5286 8.86193C15.4036 8.98695 15.3333 9.15652 15.3333 9.33333C15.3333 9.51014 15.4036 9.67971 15.5286 9.80474C15.6536 9.92976 15.8232 10 16 10Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28_4891",
    x1: 14,
    y1: 0,
    x2: 14,
    y2: 29.1546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9027E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58297B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_4891"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUUserPlus);
export default __webpack_public_path__ + "static/media/u_user-plus.30b5dcd3e0b12e659e15237b5c742959.svg";
export { ForwardRef as ReactComponent };